
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SupportTicketMessageDto } from '@/services/api-clients';
import { MediaService } from '@/services/media.service';
import { utcToLocalDatetimeFilter } from '@/filters';
import SupportTicketSaveFileDialog from '@/components/SupportTicketSaveFileDialog.vue';

@Component({
  components: { SupportTicketSaveFileDialog },
  filters: { utcToLocalDatetimeFilter },
})
export default class SupportTicketMessageBubble extends Vue {
  @Prop({ type: Object, required: true }) message!: SupportTicketMessageDto;

  saveDialog = false;

  thumbnailUrl: string | null = null;

  get isEmployee(): boolean {
    return !!this.message.userId;
  }

  get hasAttachment(): boolean {
    return !!this.message.driverId && !!this.message.attachmentFileName;
  }

  get isImage(): boolean {
    return (this.message.attachmentContentType ?? '').startsWith('image/');
  }

  mounted() {
    if (this.message.mediumId && this.isImage) {
      new MediaService().downloadFile(this.message.mediumId).then((result) => {
        this.thumbnailUrl = URL.createObjectURL(result);
      });
    }
  }

  beforeDestroy() {
    if (this.thumbnailUrl) URL.revokeObjectURL(this.thumbnailUrl);
  }

  openAttachment() {
    if (!this.message.mediumId) return;
    if (this.isImage) {
      this.$previewGallery.open([this.message.mediumId], this.message.mediumId);
      return;
    }
    // The tab opens before the download, like the driver form preview, so the browser does not block it as a popup.
    const win = window.open('', '_blank');
    new MediaService().downloadFile(this.message.mediumId).then((result) => {
      const fileURL = URL.createObjectURL(new Blob([result], { type: 'application/pdf' }));
      if (win) {
        win.location.assign(fileURL);
      }
    }).catch((errors) => {
      this.$notifier.error(errors);
    });
  }
}
